import { MessageTypeTokens, ColorTokens, } from '@voltmoney/schema';
export const messageTypeTokenMap = {
    [MessageTypeTokens.ERROR]: {
        labelColor: ColorTokens.Grey_Charcoal,
        bgColor: ColorTokens.Google,
    },
    [MessageTypeTokens.INFO]: {
        labelColor: ColorTokens.Grey_Charcoal,
        bgColor: ColorTokens.Grey_Milk_1,
    },
    [MessageTypeTokens.SUCCESS]: {
        labelColor: ColorTokens.Grey_Charcoal,
        bgColor: ColorTokens.Grey_Milk_1,
    },
    [MessageTypeTokens.WARNING]: {
        labelColor: ColorTokens.Grey_Charcoal,
        bgColor: ColorTokens.Grey_Milk_1,
    },
};
